__turbopack_context__.v({
  "className": "funnel_display_faf4555a-module__ovR8Ma__className",
  "variable": "funnel_display_faf4555a-module__ovR8Ma__variable",
});
